export const FunnelNameActionMap = {
    rta_targeting: {
        name: "Targeting",
        action: "Remove exclusion lists or add more eligible segments/deals to increase scale",
        reason: "Ad requests not eligible for plan targetings"
    },
    freq_cap: {
        name: "Frequency Cap",
        action: "Max impressions reached for users. Loosen the frequency cap to increase scale",
        reason:"Ad requests not eligible in order to not violate frequency cap"
    },
    objectives: {
        name: "Goals",
        action: "Lower goal value to increase scale",
        reason:"Ad requests not eligible because of below goal value for plan"
    },
    winrate: {
        name: "Win Rate",
        action: "N/A",
        reason: "Ad requests that fail to become impressions according to predicted win rate"
    },
    desired_price: {
        name: "Budget",
        action: "N/A",
        reason:"Ad requests not eligible because of over plan budget"
    },
    ad_requests: {
        name: "Available Ad Requests",
        action: "Based on inventory targeting, number of total ad requests over campaign flight dates not considering targeting"
    }
};
